import { get } from '../libs/Axios';
import { DataLayerUtils } from '../utilities/DataLayer';
import BaseFormComponent from '../abstracts/BaseFormComponent';
import SerializeForm from '../utilities/SerializeForm';

export default class NewsLetterComponent extends BaseFormComponent {
  get SELECTORS() {
    return {
      error: '.js-error'
    };
  }

  get CLASSES() {
    return {
      hidden: 'hide'
    };
  }

  constructor(element) {
    super(element);

    this.handleSubmit();
  }

  handleSubmit() {
    this.onSubmit((e, action, formButton) => {
      this.loading(formButton);
      const formData = new SerializeForm(e.currentTarget).getData('object');
      const siteLanguage = formData.language;
      const langPrefix = siteLanguage.substring(0, 2);
      get(action, {
        params: formData
      }).then(({ data }) => {
        if (data.error) {
          const error = this.$el.querySelector(this.SELECTORS.error);
          error.innerHTML = data.message;
          error.classList.remove(this.CLASSES.hidden);
        } else {
          this.$el.innerHTML = data;

          DataLayerUtils.push({
            event: 'asyncAction',
            gaHitType: 'event',
            category: 'iscrizione_newsletter',
            action: 'ok',
            label: langPrefix
          });
        }
      })
        .catch(console.erorr)
        .then(() => this.endLoading(formButton));
    });
  }
}
